const routes = [
  {
    path: ["/", "/home"],
    exact: true,
    component: "Home",
  },
  {
    path: ["/solutions/elv"],
    exact: true,
    component: "ElvSolution",
  },
  {
    path: ["/solutions/ai-agent"],
    exact: true,
    component: "AiAgentSolution",
  },
];

export default routes;
